import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/auth-context";
import Heading from "../UI/Heading";
import { useState, useContext } from "react";
import { DataContext } from "../../context/data-context";
import uploadFile from "../../util/upload-file";
import LoadingSpinner from "../UI/LoadingSpinner";
import { MdArrowBack } from "react-icons/md";
import { addPartnerVehicle } from "../../api/add";
import { fetchAllPartners } from "../../api/fetch";

export default function AddPartnerVehicle({ setOpen, partner }) {
  const { user } = useContext(AuthContext);
  const { fetchPartners } = useContext(DataContext);

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState();
  const [financed, setFinanced] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [item, setItem] = useState();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setWarning();
      const data = {
        partnerId: partner.id,
        vin: e.target.vin.value,
        make: e.target.make.value,
        model: e.target.model.value,
        year: e.target.year.value,
        financed: e.target.financed.checked,
      };

      if (e.target.license.value) data.license = e.target.license.value;
      if (e.target.bos.files[0]) {
        const path = `partners/${user.uid}/vehicles/${
          data.vin
        }/bos.${e.target.bos.files[0].name.split(".").pop()}`;
        setItem("Bill of Sale");
        data.bos = await uploadFile(path, e.target.bos.files[0], setUploading);
        setUploading(false);
      }
      if (e.target.title.files[0]) {
        const path = `partners/${user.uid}/vehicles/${
          data.vin
        }/title.${e.target.title.files[0].name.split(".").pop()}`;
        setItem("Title Documentation");
        data.title = await uploadFile(
          path,
          e.target.title.files[0],
          setUploading
        );
        setUploading(false);
      }
      if (e.target.registeration.files[0]) {
        const path = `partners/${user.uid}/vehicles/${
          data.vin
        }/registeration.${e.target.registeration.files[0].name
          .split(".")
          .pop()}`;
        setItem("Registeration");
        data.registeration = await uploadFile(
          path,
          e.target.registeration.files[0],
          setUploading
        );
        setUploading(false);
      }
      if (e.target.vir.files[0]) {
        const path = `partners/${user.uid}/vehicles/${
          data.vin
        }/vir.${e.target.vir.files[0].name.split(".").pop()}`;
        setItem("Inspection Report");
        data.vir = await uploadFile(path, e.target.vir.files[0], setUploading);
        setUploading(false);
      }
      if (e.target.insurance.files[0]) {
        const path = `partners/${user.uid}/vehicles/${
          data.vin
        }/insurance.${e.target.insurance.files[0].name.split(".").pop()}`;
        setItem("Insurance");
        data.insurance = await uploadFile(
          path,
          e.target.insurance.files[0],
          setUploading
        );
        setUploading(false);
      }
      if (e.target.poa.files[0]) {
        const path = `partners/${user.uid}/vehicles/${
          data.vin
        }/poa.${e.target.poa.files[0].name.split(".").pop()}`;
        setItem("Power of Attorney");
        data.poa = await uploadFile(path, e.target.poa.files[0], setUploading);
        setUploading(false);
      }
      if (financed) {
        data.institution = e.target.institution.value;
        data.amount = e.target.amount.value;
        data.term = e.target.term.value;
        data.monthly = e.target.monthly.value;
        if (e.target.loan.files[0]) {
          const path = `partners/${user.uid}/vehicles/${
            data.vin
          }/loan.${e.target.loan.files[0].name.split(".").pop()}`;
          setItem("Loan Documents");
          data.loan = await uploadFile(
            path,
            e.target.loan.files[0],
            setUploading
          );
          setUploading(false);
        }
      }

      const response = await addPartnerVehicle(user, data);
      setLoading(false);
      fetchPartners(() => navigate(`/partners/info?id=${partner.id}`));
    } catch (err) {
      console.log(err);
      setWarning(err.message);
      setLoading(false);
    }
  };

  return (
    <div className="container grid content-start gap-6">
      <Heading title="Add Partner Vehicle">
        <MdArrowBack
          onClick={() => setOpen(false)}
          className="text-lg text-white cursor-pointer hover:text-stone-400"
        />
      </Heading>
      <form onSubmit={submitHandler} className="grid gap-6">
        <div className="grid gap-2 md:grid-cols-4">
          <div className="grid">
            <label className="form-label">Partner:</label>
            <input
              className="form-input-disabled"
              name="partner"
              disabled
              value={partner.name}
            />
          </div>
          <div className="grid">
            <label className="form-label">VIN Number:</label>
            <input className="form-input" name="vin" required />
          </div>
          <div className="grid">
            <label className="form-label">Make:</label>
            <input className="form-input" name="make" required />
          </div>
          <div className="grid">
            <label className="form-label">Model:</label>
            <input className="form-input" name="model" required />
          </div>
          <div className="grid">
            <label className="form-label">Year:</label>
            <input className="form-input" name="year" required />
          </div>
          <div className="grid">
            <label className="form-label">License:</label>
            <input className="form-input" name="license" />
          </div>
          <div className="grid">
            <label className="form-label">Bill of Sale:</label>
            <input className="form-input" type="file" name="bos" />
          </div>
          <div className="grid">
            <label className="form-label">Title Documents:</label>
            <input className="form-input" type="file" name="title" />
          </div>
          <div className="grid">
            <label className="form-label">Registeration:</label>
            <input className="form-input" type="file" name="registeration" />
          </div>
          <div className="grid">
            <label className="form-label">Inspection Report:</label>
            <input className="form-input" type="file" name="vir" />
          </div>
          <div className="grid">
            <label className="form-label">Insurance Documents:</label>
            <input className="form-input" type="file" name="insurance" />
          </div>
          <div className="grid">
            <label className="form-label">Power of Attorney:</label>
            <input className="form-input" type="file" name="poa" />
          </div>
        </div>

        <div className="form-checkbox">
          <label className="form-label">Financed:</label>
          <input
            type="checkbox"
            className="checkbox"
            onChange={(e) => setFinanced(e.target.checked)}
            name="financed"
          />
        </div>

        {financed && (
          <div className="grid gap-2 md:grid-cols-4">
            <div className="grid">
              <label className="form-label">Financing Institution:</label>
              <input className="form-input" name="institution" />
            </div>

            <div className="grid">
              <label className="form-label">Finance Amount:</label>
              <input className="form-input" name="amount" />
            </div>

            <div className="grid">
              <label className="form-label">Term (months):</label>
              <input className="form-input" name="term" />
            </div>

            <div className="grid">
              <label className="form-label">Monthly Payment:</label>
              <input className="form-input" name="monthly" />
            </div>

            <div className="grid">
              <label className="form-label">Loan Documents:</label>
              <input className="form-input" type="file" name="loan" />
            </div>
          </div>
        )}

        <div className="grid items-center gap-4 md:grid-cols-3">
          {loading ? (
            <LoadingSpinner />
          ) : (
            <button className="mt-4 btn-primary" type="submit">
              Submit
            </button>
          )}
          {uploading && (
            <p className="text-stone-400">
              Uploading {item}: {uploading}%
            </p>
          )}
          {warning && <p className="text-red-600">{warning}</p>}
        </div>
      </form>
    </div>
  );
}
